'use strict';

module.exports = /*@ngInject*/ function() {
    return function(input, start)
    {
        start = +start;
        return input.slice(start);
    };
};